<div class="d-flex confirmation-border align-items-center p-2 bg-white">
    <div>
        <p>Are you sure you want to cancel?</p>
        <p>This action will discard any unsaved changes.</p>
    </div>
    <div class="ms-3">
        <telxl-button
            cdkFocusInitial
            colour="dark"
            [outline]="true"
            (buttonClick)="confirm.emit()"
        >
            Close
        </telxl-button>
    </div>
</div>
